import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DictionaryActions from './DictionaryActions';
import NoContent from '../../sections/no-content/NoContent';
import UserAvatar from '../../sections/user-avatar/UserAvatar';

const SynonymDictionaryTable = ({ list, ...dictionaryActions }) => {
  const { t } = useTranslation();

  const TABLE_HEADERS = [
    t('synonym.dictionaryName', { ns: 'project' }),
    t('creator', { ns: 'project' }),
  ];

  return (
    <>
      {!isEmpty(list) ? (
        <TableContainer>
          <Table size="small" aria-label="dictionary-table">
            <TableHead>
              <TableRow>
                {TABLE_HEADERS.map((header, i) => (
                  <TableCell align={i !== 0 ? 'center' : 'left'} key={header}>
                    {header}
                  </TableCell>
                ))}
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((item, index) => (
                <TableRow key={index} aria-label="table row">
                  <TableCell>{item.name}</TableCell>
                  <TableCell align="center" width={200}>
                    <UserAvatar user={item.author} />
                  </TableCell>
                  <TableCell align="right" width={200}>
                    <DictionaryActions
                      dictionary={item}
                      {...dictionaryActions}
                      isTableRow
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <NoContent title={t('noSynonymDictionary', { ns: 'descriptions' })} />
      )}
    </>
  );
};

SynonymDictionaryTable.propTypes = {
  list: PropTypes.array,
};

export default SynonymDictionaryTable;
